import { FC } from "react";
import Image from "next/image";
import styles from "./EmptyData.module.scss";
import classNames from "classnames";

interface EmptyDataProps {
  text: string;
  size?: "small" | "medium";
}

const EmptyData: FC<EmptyDataProps> = ({ text, size = "medium" }) => {
  const imageWidth = {
    small: 100,
    medium: 160,
  };

  const imageHeight = {
    small: 100,
    medium: 160,
  };

  return (
    <div
      className={classNames(styles.empty_data, styles[size])}
      data-aos="fade-up"
    >
      <Image
        src="/svgs/empty.svg"
        alt="Empty"
        width={imageWidth[size]}
        height={imageHeight[size]}
      />

      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default EmptyData;
